import React, { useEffect, useState } from 'react';
import axios from 'Uitilities/axios';
import { useSearchParams } from 'react-router-dom';
import Table from 'Components/Table';

const TestListResult = ({ searchCondition, bridgeData, setbridgeData, setselectedBridge , specialBridge}) => {
  const [searchParams] = useSearchParams();


  const getApiEndpoint = () => {
    const specialBridge = searchParams.get('specialBridge');
    if (specialBridge === 'Y') {
      return 'https://tybms.tycg.gov.tw/newApi/BridgeTest/GetBridgeNextTestYearSB';
    } else {
      return 'https://tybms.tycg.gov.tw/newApi/BridgeTest/GetBridgeNextTestYear';
    }
  };

  // 定義顯示的欄位
  const getColumns = () => {
    const testYear = searchParams.get('testYear');
    const baseColumns = [
      {
        dataField: "BridgeName",
        text: "橋梁名稱",
      },
      {
        dataField: "Town",
        text: "所在區鄉",
      },
      {
        dataField: "RHM_nextTestYear",
        text: "反彈錘檢測",
      },
      {
        dataField: "TCIC_nextTestYear",
        text: "混凝土氯離子檢測",
      },
      {
        dataField: "ACT_nextTestYear",
        text: "混凝土中性化深度檢測",
      },
      {
        dataField: "CSDCC_nextTestYear",
        text: "混凝土鑽心抗壓強度",
      },
      {
        dataField: "MCT_nextTestYear",
        text: "鋼構塗膜厚度檢測",
      },
      {
        dataField: "CR_nextTestYear",
        text: "腐蝕電位檢測",
      },
    ];

    if (testYear === 'thisYear') {
      baseColumns.push({
        dataField: "TestThisYearCount",
        text: "今年建議試驗數量",
        sort: true,
      });
    } else if (testYear === 'nextYear') {
      baseColumns.push({
        dataField: "TestNextYearCount",
        text: "明年建議試驗數量",
        sort: true,
      });
    }

    return baseColumns;
  };

  const Download = async () => {
    try {
      const response = await axios({
        method: 'post',
        url: 'https://tybms.tycg.gov.tw/newApi/BridgeTest/ExportTestListExcel', 
        data: bridgeData, // 傳送目前的篩選資料
        responseType: 'blob',
      });
  
      // 創建下載鏈接並觸發下載
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '待試驗清單.xlsx'); // 設定檔案名稱
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('匯出失敗:', error);
      alert('匯出失敗，請稍後再試');
    }
  };

  // 調整 API 請求邏輯，發送新的查詢參數
  async function getBridgeInformation() {
    const apiEndpoint = getApiEndpoint();
    const testYear = searchParams.get('testYear');

    // 根據 searchCondition 構建查詢參數
    const queryParams = {
      bridgeName: searchCondition.find(cond => cond.key === 'bridgeName')?.value || null,
      bridgeNumber: searchCondition.find(cond => cond.key === 'bridgeNumber')?.value || null,
      testName: searchCondition.find(cond => cond.key === 'testName')?.value || null,
    };

    await axios.get(apiEndpoint, { params: queryParams })
      .then(res => {
        let filteredData = res.data;
        if (testYear === 'thisYear') {
          filteredData = res.data.filter(item => item.TestThisYearCount > 0);
        } else if (testYear === 'nextYear') {
          filteredData = res.data.filter(item => item.TestNextYearCount > 0);
        }

        console.log("API response:", filteredData);
        setbridgeData(filteredData);
      })
      .catch(err => alert(err));
  }

  useEffect(() => {
    // 默認進入頁面時顯示全部資料
    getBridgeInformation();
  }, [specialBridge]);

  useEffect(() => {
    if (searchCondition.length > 0) {
      getBridgeInformation();
    }
  }, [searchCondition, searchParams]);

  useEffect(() => {
    console.log("searchCondition updated:", searchCondition);
    getBridgeInformation();
  }, [searchCondition]);

  useEffect(() => {
    console.log("bridgeData updated:", bridgeData);
  }, [bridgeData]);

  useEffect(() => {
    console.log("TestPrioritySearch 已渲染");
  }, []);

  return (
    <>
      <div className="searchResult">
        <div className="text-left d-flex">
          <h5>篩選結果</h5>
        </div>
      </div>
      <Table 
  data={bridgeData} 
  columns={getColumns()} 
  fileName="待試驗清單.xlsx"  download={Download}
  keyField={"id"} 
  defaultSorted={[
    {
      dataField: searchParams.get('testYear') === 'thisYear' 
        ? "TestThisYearCount" 
        : "TestNextYearCount",
      order: "desc", // 默認降序排序
    },
  ]}
/>
    </>
  );
};

export default TestListResult;
